module.exports = __webpack_public_path__ + "img/beaver_transport.be76c79b.png";